import React from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { Link as RouterLink } from "react-router-dom";

function HomePrivacy() {
    return (
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 2.25, md: 3.25 },
                    borderRadius: 4,
                    border: "1px solid rgba(148, 163, 184, 0.18)",
                    background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)",
                    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
                }}
            >
                <Stack spacing={1.8}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1.4,
                        }}
                    >
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                minWidth: 44,
                                borderRadius: 2.5,
                                bgcolor: "rgba(37,99,235,0.10)",
                                color: "#2563eb",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <ShieldOutlinedIcon sx={{ fontSize: 24 }} />
                        </Box>

                        <Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 800,
                                    color: "#0f172a",
                                    fontSize: { xs: "1.12rem", md: "1.35rem" },
                                    lineHeight: 1.25,
                                    mb: 0.8,
                                }}
                            >
                                Конфиденциальность и бережная работа с данными
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#475569",
                                    lineHeight: 1.7,
                                    fontSize: { xs: "0.95rem", md: "1rem" },
                                }}
                            >
                                Qarzhy не создает архив банковских документов и не
                                предназначен для хранения персональных данных как
                                отдельного массива. Загруженные файлы используются только
                                в рамках текущего сценария обработки: система анализирует
                                документы, показывает результат и формирует отчет для
                                дальнейшей работы пользователя.
                            </Typography>
                        </Box>
                    </Box>

                    <Typography
                        sx={{
                            color: "#475569",
                            lineHeight: 1.7,
                            fontSize: { xs: "0.95rem", md: "1rem" },
                        }}
                    >
                        Для стабильной работы и контроля доступа используется только
                        ограниченное техническое логирование: сведения об авторизации,
                        типах операций, длительности обработки, сценариях работы,
                        подключенных банках и общем количестве загруженных файлов — без
                        избыточного накопления чувствительной информации.
                    </Typography>

                    <Typography
                        component={RouterLink}
                        to="/privacy"
                        sx={{
                            alignSelf: "flex-start",
                            color: "#2563eb",
                            fontWeight: 700,
                            fontSize: "0.95rem",
                            textDecoration: "none",
                            transition: "opacity 0.2s ease",
                            "&:hover": {
                                opacity: 0.8,
                                textDecoration: "underline",
                            },
                        }}
                    >
                        Подробнее в Политике конфиденциальности
                    </Typography>
                </Stack>
            </Paper>
        </Container>
    );
}

export default HomePrivacy;